import React, { FC } from 'react'

import { SuccessPromptTactic } from '@Domains/Cart/Components/Prompt/Successv2/SuccessPrompt'
import { CartV2LineItem } from '@Domains/Cart/Feature/CartV2/CartV2'
import { BuildYourDiscountTactic } from '@Domains/Product/Features/Tactics/Components/BuildYourDiscount/BuildYourDiscountTactic'
import { ProductQuantityDiscount } from '@Domains/Product/Features/Tactics/Components/ProductQuantityDiscount/ProductQuantityDiscount'
import { QuantityDiscountV2 } from '@Domains/Product/Features/Tactics/Components/QuantityDiscount/QuantityDiscountV2'
import { AddAndSaveTacticV2 } from '@Domains/Product/Features/Tactics/Components/TacticAddAndSave/AddAndSaveTacticV2'
import { Product, ProductTactics, TacticAddAndSave } from '@Generated/graphql'

import styles from './ProductTactics.module.scss'

export type TacticOffer = NonNullable<NonNullable<TacticAddAndSave['offers']>[0]>

interface ProductTacticsProps {
  addonsSelected?: boolean
  relatedLineItem?: CartV2LineItem
  relatedProduct?: Product
  showProgressBar?: boolean
  tactics?: ProductTactics['gold'] | SuccessPromptTactic[]
}
export const LegacyProductTacticsDoNotUse: FC<ProductTacticsProps> = ({ addonsSelected, relatedLineItem, relatedProduct, showProgressBar, tactics }) => {
  if (!tactics) {
    return null
  }

  if (!relatedLineItem && relatedProduct) {
    return (
      <div className={styles.productTactics}>
        {tactics.map((tactic) => {
          if (tactic.__typename === 'TacticBuildYourDiscount') {
            return (
              <BuildYourDiscountTactic
                key={`TacticBuildYourDiscount_${tactic.id}`}
                disable={addonsSelected}
                primaryProduct={relatedProduct}
                tactic={tactic}
              />
            )
          } if (tactic.__typename === 'TacticRelativeDiscount') {
            return (
              <ProductQuantityDiscount
                key={`TacticBuildYourDiscount_${tactic.id}`}
                primaryProduct={relatedProduct}
                tactic={tactic}
              />
            )
          }
          return null
        })}
      </div>
    )
  }
  if (relatedLineItem && relatedLineItem.product) {
    return (
      <div className={styles.productTactics}>
        {tactics.map((tactic) => {
          if (tactic.__typename === 'TacticRelativeDiscount') {
            return (
              <QuantityDiscountV2
                key={`QuantityDiscount_${tactic.id}`}
                lineItem={relatedLineItem}
                showProgressBar={showProgressBar}
                tactic={tactic}
              />
            )
          }
          if (tactic.__typename === 'TacticAddAndSave') {
            return (
              <AddAndSaveTacticV2
                key={`TacticAddAndSave_${tactic.id}`}
                lineItem={relatedLineItem}
                showProgressBar={showProgressBar}
                tactic={tactic}
              />
            )
          }
          return null
        })}
      </div>
    )
  }
  return null
}
